<div class="nav-container-separator"></div>
<div class="row eip-form-controls eip-mt-10 eip-pl-10 eip-pr-10">
    <div class="col-sm-12 p-0">
        <div class="carousel-container p-0 d-flex">
            <div class="d-flex align-items-center"><i (click)="leftMove()" class="fa fa-angle-left carousel-prev-btn eip-mr-10 eip-ml-0" id="ibtMaterialForward" aria-hidden="true"></i></div>
            <div id="carousel-container" (wheel)="onWheel($event)">
                <div class="main-wrapper d-flex flex-row align-items-center">
                    <div class="d-flex align-items-center" *ngFor="let task of currentWorkflowDetails?.workflowStatus; let index = index">
                        <div class="">
                            <input type="hidden" value="{{task.workflow_Status}}">
                            <input type="submit" value="{{getWorkflowStatusName(task.sub_Workflow)}} - {{task.workflow_Status_Description}}" class="btn btn-stepper" id="btnTask_{{task.workflow_Status}}" [ngClass]="{'active' : (task.sub_Workflow == wfInputDetails.subWorkflow && task.workflow_Status_Description.toUpperCase().trim() === wfInputDetails.taskName.toUpperCase().trim())}">
                        </div>
                        <div class="color-green" *ngIf="(index != (currentWorkflowDetails.workflowStatus.length - 1))"></div>
                        <div *ngIf="(index != (currentWorkflowDetails.workflowStatus.length - 1))">
                            <p class="arrow-right"></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex align-items-center"><i (click)="rightMove()" class="fa fa-angle-right carousel-next-btn eip-mr-0  eip-ml-10" id="ibtmaterialBackward" aria-hidden="true"></i></div>
        </div>
    </div>
</div>
<div class="eip-mt-10 eip-mb-10 heder-seperator bb-1">
    <div class="d-flex align-items-center eip-mb-5">
        <div class="d-flex flex-wrap eip-mr-20 flex-grow-1">
            <span class="fs-15 ff-3">{{wfInputDetails.taskName}}</span>
            <div class="icons-container view-page-wrap-icons d-flex">
                <i class="fa fa-history" title="Workflow History" (click)="onClick_WorkflowHistory(wfInputDetails)" aria-hidden="true"></i>
            </div>
        </div>
        <div class="d-flex justify-content-end">
            <div class="icons-container view-page-wrap-icons d-flex">
                <div *ngFor="let action of currentWorkflowDetails?.workflowAction; let index = index">
                    <div *ngIf="holded" >
                        <i  [disabled]="show" *ngIf="(action.task_Id == wfInputDetails.currentTaskId && !action?.set_disable && !isBulkAction)" [ngClass]="action.action_Description === 'Hold' ? '' : action.action_Description === 'Send Back' ? 'fa fa-share-o rly' : action.action_Description === 'Approve' ? 'fa fa-check-circle' : 'fa fa-ban'" title="{{action.action_Description}}" (click)="onclick_action(action,wfInputDetails)" aria-hidden="true"></i>
                    </div>
                    <div *ngIf="!holded" >
                        <i [disabled]="show" *ngIf="(action.task_Id == wfInputDetails.currentTaskId && !action?.set_disable && !isBulkAction)" [ngClass]="action.action_Description === 'Hold' ? 'fa fa-hold' : action.action_Description === 'Send Back' ? 'fa fa-share-o rly' : action.action_Description === 'Approve' ? 'fa fa-check-circle' : 'fa fa-ban'" title="{{action.action_Description}}" (click)="onclick_action(action,wfInputDetails)" aria-hidden="true"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row eip-form-controls eip-mt-15">
    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
        <div class="view-info eip-mb-20">
            <p class="view-label">Document No.</p>
            <p id="lblIc" class="view-data">{{wfInputDetails.documentNumber}}</p>
        </div>
    </div>
    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
        <div class="view-info eip-mb-20">
            <p class="view-label">Title</p>
            <p id="lblCluster" class="view-data">{{wfInputDetails.documentTitle}}</p>
        </div>
    </div>
    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
        <div class="view-info eip-mb-20">
            <p class="view-label">Revision No</p>
            <p id="lblCompanyCurrency" class="view-data">{{wfInputDetails.revisionNo}}</p>
        </div>
    </div>
    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
        <div class="view-info eip-mb-20">
            <p class="view-label">Assigned On</p>
            <p id="lblSubCategeory" class="view-data">{{getFormattedDate(wfInputDetails.assignedOn)}}</p>
        </div>
    </div>
    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
        <div class="view-info eip-mb-20">
            <p class="view-label">Due On</p>
            <p id="lblStatus" class="view-data">
                {{getFormattedDate(wfInputDetails.dueOn)}}
            </p>
        </div>
    </div>
    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="isNoOfSheetsRequired == true">
        <mat-form-field>
            <mat-label>No of Sheets</mat-label>
            <input matInput [(ngModel)]="wfInputDetails.noOfSheets">
        </mat-form-field>
    </div>
</div>
<div class="row">
    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="Can_Update_DCI_Progress_Level">
        <EIPAutoComplete TextField="dedDescription" ValueField="dedId" WaterMarkText="Progress Level *" ShowTextValueField='N' [dataSource]='ProgressLevelsList' [IsCascading]='true' (valueChange)='GetProgressLevel($event)'>
        </EIPAutoComplete>
    </div>
    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="isApprovalStatusRequired">
        <EIPAutoComplete TextField="dedDescription" ValueField="dedId" WaterMarkText="Approval Status *" ShowTextValueField='N' [dataSource]='docCategoryList' [IsCascading]='true' (valueChange)='getDocCategoryValue($event)'>
        </EIPAutoComplete>
    </div>
    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
        <mat-form-field>
            <mat-label>General Comments (if any)</mat-label>
            <input matInput [(ngModel)]="wfInputDetails.comments">
        </mat-form-field>
    </div>
    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12" [hidden]="!showholdTextinput">
        <mat-form-field>
            <mat-label>Holding Reason (if hold*)</mat-label>
            <input matInput [(ngModel)]="holdReason">
        </mat-form-field>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12" *ngIf="isDelayed">
        <form [formGroup]="drForm">
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12" *ngIf="isDelayed">
                    <EIPAutoComplete TextField="delayReason" ValueField="delayReasonId" WaterMarkText="Delay Reason *" formControlName="delayReasonDD" setId="delayReasonId" ShowTextValueField='N' [dataSource]='delayReasonList' [IsCascading]='true' (valueChange)='onselectedValueChange($event,"drForm","delayReasonDD")'>
                    </EIPAutoComplete>
                    <mat-error *ngIf="drForm.get('delayReasonDD').touched && drForm.get('delayReasonDD').hasError('required')" style="margin-top: -15px;">
                        Delay Reason is required
                    </mat-error>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field *ngIf="delayReasonDD == 1">
                        <mat-label>Delay Reason Comments</mat-label>
                        <input matInput  [(ngModel)]="wfInputDetails.delayReason" formControlName="txtDRC" required>
                        <mat-error *ngIf="drForm.get('txtDRC').hasError('required')">
                            Delay Reason Comments is required
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field *ngIf="delayReasonDD == 2">
                        <mat-label>Internal Reason Comments</mat-label>
                        <input matInput  [(ngModel)]="wfInputDetails.internalReason" formControlName="txtIRC" required>
                        <mat-error *ngIf="drForm.get('txtIRC').hasError('required')">
                            Internal Reason Comments is required
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field *ngIf="delayReasonDD == 3">
                        <mat-label>External Reason Comments</mat-label>
                        <input matInput  [(ngModel)]="wfInputDetails.externalReason" formControlName="txtERC" required>
                        <mat-error *ngIf="drForm.get('txtERC').hasError('required')">
                            External Reason Comments is required
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </div>
</div>
<div>
    <kendo-grid #filecGrid [kendoGridBinding]="fileCollection" [style.maxHeight]="540" [pageable]="false" [sortable]="true" [resizable]="true" [reorderable]="true" [filterable]="false" [selectable]="false" [scrollable]="true" class="form-group-grid auto-complete-equal k-resizable-grid">
        <ng-template kendoPagerTemplate>
            <div class="k-pager-left">
                <kendo-pager-info></kendo-pager-info>
            </div>
            <div class="k-pager-right">
                <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                <kendo-pager-input></kendo-pager-input>
                <kendo-pager-next-buttons></kendo-pager-next-buttons>
            </div>
        </ng-template>
        <ng-template kendoGridToolbarTemplate>
            <div class="k-grid-toolbar-content justify-content-between d-flex">
                <div class="flex-grow-1 title-container">
                    <p class="title">Attached File Details</p>
                </div>
                <div class=""><i class="fa fa-upload fs-20 eip-pr-10" title="Attachment" (click)="attachmentClick()" style="cursor:pointer;" aria-hidden="true"></i><span class="ff-2" style="cursor:pointer;" (click)="attachmentClick()">Upload Attachments </span>
                </div>
            </div>
        </ng-template>
        <kendo-grid-column field="serial" title="Sl.No." width="60">
        </kendo-grid-column>
        <kendo-grid-column field="fileName" hidden="true"></kendo-grid-column>
        <kendo-grid-column field="fileSize" hidden="true"></kendo-grid-column>
        <kendo-grid-column field="fileExtension" hidden="true"></kendo-grid-column>
        <kendo-grid-column field="fileFullName" title="File Name" width="150">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.fileFullName}}" eipTooltipPosition="auto">
                    {{dataItem.fileFullName}}
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="fileTypeName" title="File Type" width="100">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.fileTypeName}}" eipTooltipPosition="auto">
                    {{dataItem.fileTypeName}}
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="uploadedBy" hidden="true"></kendo-grid-column>
        <kendo-grid-column field="uploadedByName" title="Attached By" width="90">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.uploadedByName}}" eipTooltipPosition="auto">
                    {{dataItem.uploadedByName}}
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="uploadedOn" title="Attached On" width="120">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.uploadedOn}}" eipTooltipPosition="auto">
                    {{dataItem.uploadedOn}}
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="action" title="Actions" width="100">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <div #divIcon class="icon-container d-flex align-items-center">
                    <i class="fa fa-download icon-my-10" (click)="downloadFile(dataItem)" style="font-size: 1.25em; cursor: pointer;" aria-hidden="true"  title="Download" id="btnDownload"></i>
                    <i *ngIf="!!dataItem.urn" class="fa fa-eye icon-my-10" aria-hidden="true" style="font-size: 1.25em; cursor: pointer;" title="View" id="btnView" (click)="viewFile(dataItem)"></i>
                    <i class="fa fa-trash" title="Delete" (click)="deleteFile(dataItem)" style="font-size: 1.25em; cursor: pointer;" *ngIf="dataItem.isDeleteEnable == true" aria-hidden="true"></i>
                </div>
            </ng-template>
        </kendo-grid-column>
    </kendo-grid>
</div>
<div class="row m-0 eip-pt-20" *ngIf="isChecklistRequired == true">
    <div class="col-xl-5 col-lg-5 col-md-5 col-sm-10 col-xs-10 pl-0">
        <EIPAutoComplete ShowTextValueField='N' [clearValue]='setclear' style="width:40%" WaterMarkText="Select Checklist" [defaultValue]="selectedChecklist" ValueField="clId" TextField="clFullDescription" [dataSource]='checklistCollection' [IsDisabled]="addCheckList" [IsCascading]='true' (valueChange)='onChange_Checklist($event)'>
        </EIPAutoComplete>
    </div>
    <div style="margin-top: 1%;">
        <i class="fa fa-plus-circle fs-20" [ngClass]="addCheckList ? 'setDisable' : 'removeDisable'" title="Add" aria-hidden="true" (click)="onclick_AddChecklist()"></i>
    </div>
    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-6" style="margin-top: 1%;">
        <mat-slide-toggle color="primary" [(ngModel)]="isShowICSpecific" (change)="ShowICSpecific_Checklist()">Show
            IC Specific Checklist</mat-slide-toggle>
    </div>
    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-6" style="margin-top: 0.5%;">
        <div *ngIf="isShow_checklist_option">
            <mat-label class="font-weight-bold eip-mr-10">Checklist : </mat-label>
            <mat-button-toggle-group #group="matButtonToggleGroup" class="sche-quantity" aria-label="Checklist" [value]='Checklist' (change)="checkListChange($event.value)">
                <mat-button-toggle value="A">Applicable</mat-button-toggle>
                <mat-button-toggle value="NA">Not Applicable</mat-button-toggle>
            </mat-button-toggle-group>
        </div>
    </div>
    <div style="margin-top: 0.5%;">
        <button class="btn btn-primary eip-ml-10" [disabled]="addCheckList" (click)="getPreviousChecklist()">Previous
            Revision Checklist</button>
    </div>
</div>
<div class="row m-0 eip-pt-20" *ngIf="isChecklistRequired == true">
    <kendo-grid #checkListcGrid [data]="selectedChecklistCollection" [style.maxHeight]="540" [pageable]="false" [sortable]="false" [resizable]="false" [reorderable]="false" [filterable]="enableFilter" [selectable]="false" [scrollable]="false" class="form-group-grid auto-complete-equal k-resizable-grid">
        <kendo-grid-column field="clId" hidden="true"></kendo-grid-column>
        <kendo-grid-column field="clFullName" title="Checklist Name" width="150">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.clFullName}}" eipTooltipPosition="auto">{{dataItem.clFullName}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="uploadedByName" title="Attached By" width="90">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.uploadedByName}}" eipTooltipPosition="auto">{{dataItem.uploadedByName}}</span>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="uploadedOn" width="120" title="Attached On">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{getFormattedDate(dataItem.uploadedOn)}}" eipTooltipPosition="auto">{{getFormattedDate(dataItem.uploadedOn)}}</span>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="action" title="Actions" width="100">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <div #divIcon class="icon-container d-flex align-items-center">
                    <i class="fa fa-external-link" title="Checklist Items" (click)="openChecklistItems(dataItem)" aria-hidden="true"></i>
                    <i class="fa fa-trash" *ngIf="dataItem.deleteicon" title="Delete" (click)="deleteChecklist(dataItem)" aria-hidden="true"></i>
                </div>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column width="50">
            <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex" title="Actions">
                <i *ngIf="selectedChecklistCollection.length>0" class="fa fa-clone icon-size mr-2" matTooltip="Copy Checklist" style="font-size: 15px; cursor: pointer;margin-left: 3%;" id="" aria-hidden="true" (click)="EmitCopyDetails()"></i>
            </ng-template>
        </kendo-grid-column>
    </kendo-grid>
</div>
<div class="row m-0 eip-pt-20" *ngIf="isTenderQuantityRequired == true">
    <div class="d-flex eip-p-10  p-10">
        <mat-label class="font-weight-bold eip-mr-10">Tender Quantity : </mat-label>
        <mat-button-toggle-group #group="matButtonToggleGroup" class="sche-quantity" aria-label="Quantity" [value]='isQuantityApplicable' (change)="onQuantityChange($event.value)">
            <mat-button-toggle value="A">Applicable</mat-button-toggle>
            <mat-button-toggle value="NA">Not Applicable</mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <div class="icons-container view-page-wrap-icons d-flex" *ngIf='isQuantityApplicable=="A"'>
        <i class="fa fa-external-link" (click)="openTenderQuantity()" value="Tender Quantity" aria-hidden="true"></i>
    </div>
</div>

<div class="row m-0 eip-pt-20" *ngIf="isCommentSheetRequired == true">
    <div class="d-flex align-items-center" style="width: 15%;">
        <mat-form-field>
            <mat-label>Enter Transmittal Number</mat-label>
            <input matInput [(ngModel)]="isCommentSheetno">
        </mat-form-field>
    </div>
</div>
<div class="row m-0 eip-pt-20" *ngIf="isCompletedOnManulRequired == true">
    <div class="d-flex align-items-center">
        <div><label class="mb-0">Completed on</label></div>
        <div class="eip-ml-10 eip-mtm-20">
            <EIPDatePicker setid="dtCompletedOn" [Value]=defaultDateValue (selectedDate)='getCompletedOnValue($event)' [IsDateReadonly]='icIsDisabled' (selectedTime)='getTimeValue($event)' [Max]=max [Min]=min>
            </EIPDatePicker>
        </div>
    </div>
</div>

<div class="eip-mt-20 eip-mb-10" *ngIf="!!supersedeActions && supersedeActions.length > 0">
    <h6 class="mb-1" [innerHTML]="getReviseRevisionDetailsHeader()" style="font-weight: 400;"></h6>
    <form [formGroup]="revForm" autocomplete="off">
        <div class="row">
            <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <EIPAutoComplete TextField="revCategory" ValueField="revCategoryId" WaterMarkText="Rev Category *" formControlName="formrevCategory" ShowTextValueField='N' [dataSource]='revCategoryList' [IsCascading]='true' [defaultValue]="wfInputDetails.revisionCategory" (valueChange)='onselectedValueChange($event,"revForm","revCategory")'>
                </EIPAutoComplete>
                <mat-error *ngIf="revForm.get('formrevCategory').touched && revForm.get('formrevCategory').hasError('required')" style="margin-top: -15px;">
                    Revision Category is required
                </mat-error>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <EIPAutoComplete TextField="dedDescription" ValueField="dedId" WaterMarkText="Released For *" formControlName="formDciStatus" required ShowTextValueField='N' [dataSource]='dciStatusList' [IsCascading]='true' [defaultValue]="wfInputDetails.status" (valueChange)='onselectedValueChange($event,"revForm","dciStatus")'>
                </EIPAutoComplete>
                <mat-error *ngIf="revForm.get('formDciStatus').touched && revForm.get('formDciStatus').hasError('required')" style="margin-top: -15px;">
                    Released For is required
                </mat-error>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <EIPAutoComplete TextField="dedDescription" ValueField="dedId" WaterMarkText="Print Size *" formControlName="formPrintSize" ShowTextValueField='N' [dataSource]='printSizeList' [IsCascading]='true' [defaultValue]="wfInputDetails.printSize" (valueChange)='onselectedValueChange($event,"revForm","printSize")'>
                </EIPAutoComplete>
                <mat-error *ngIf="revForm.get('formPrintSize').touched && revForm.get('formPrintSize').hasError('required')" style="margin-top: -15px;">
                    Print Size is required
                </mat-error>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <mat-form-field>
                    <mat-label>No of Sheets</mat-label><input matInput formControlName="noOfSheets" [(ngModel)]="wfInputDetails.noOfSheets">
                </mat-form-field>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <mat-form-field>
                    <mat-label>Comments</mat-label><input matInput formControlName="comments" [(ngModel)]="wfInputDetails.comment">
                </mat-form-field>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="!isDocSetRequired">
                <mat-form-field>
                    <mat-label>Revision</mat-label><input matInput formControlName="formRevision" required>
                    <mat-error *ngIf="revForm.get('formRevision').hasError('required')">
                        Revision is required
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngFor="let item of LatestStageDetails">
                <p class="create-page-label">
                    <mat-label>{{item.stage_Short_Desc}}-{{item.stage_Desc}}</mat-label>
                </p>
                <p class="create-page-data">
                    <EIPDatePicker setid="item.stage_Short_Desc" [Value]=(item.revisedScheduled_On?item.revisedScheduled_On:item.scheduled_On) (selectedDate)='setStageDate($event,item)' [Min]=item.minScheduled_On [Max]=item.maxScheduled_On [IsDateReadonly]=!item.isUpdatable [IsDateDisabled]=!item.isUpdatable>
                    </EIPDatePicker>
                </p>
            </div>
        </div>
    </form>
</div>

<div *ngIf="!isBulkAction" class="justify-content-end d-flex eip-mb-20 eip-mt-20">
    <div *ngFor="let action of currentWorkflowDetails?.workflowAction; let index = index">
        <div *ngIf="holded">
            <button type="button" value="{{action.action_Description}}" class="btn btn-primary eip-ml-10" (click)="onclick_action(action,wfInputDetails)" [disabled]="action?.set_disable" [disabled]="action.action_Description === 'Hold'" *ngIf="(action.task_Id == wfInputDetails.currentTaskId)">{{action.action_Description}}</button>
        </div>
        <div *ngIf="!holded">
            <button type="button" value="{{action.action_Description}}" class="btn btn-primary eip-ml-10" (click)="onclick_action(action,wfInputDetails)" [disabled]="action?.set_disable" *ngIf="(action.task_Id == wfInputDetails.currentTaskId)">{{action.action_Description}}</button>
        </div>
    </div>
</div>
<div class="justify-content-end d-flex eip-mb-20 eip-mt-20" *ngIf="isBulkAction">
    <div>
        <EIPAutoComplete TextField="action_Description" ValueField="action_Id" WaterMarkText="Select Action*" ShowTextValueField='N' [dataSource]='ListofActiondetails' [IsCascading]='true' [defaultValue]="action_id" (valueChange)='OnselectionChange($event)'>
        </EIPAutoComplete>
    </div>
</div>
<div *ngIf="IsShow">
    <kendo-grid [kendoGridBinding]="getworkflowHistoryvalue" [reorderable]="true" [sortable]="true" [resizable]="true" [filterable]="enableFilter" [pageSize]="10" [pageable]="true">
        <ng-template kendoPagerTemplate>
            <div class="k-pager-left">
                <kendo-pager-info></kendo-pager-info>
            </div>
            <div class="k-pager-right">
                <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                <kendo-pager-input></kendo-pager-input>
                <kendo-pager-next-buttons></kendo-pager-next-buttons>
            </div>
        </ng-template>
        <ng-template kendoGridToolbarTemplate>
            <div class="k-grid-toolbar-content justify-content-between d-flex">
                <div class="flex-grow-1 title-container">
                    <p class="title">Previous Step Action Detail</p>
                </div>
            </div>
        </ng-template>
        <kendo-grid-column title="Document No" field="documentNumber" width="150">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.documentNumber}}" eipTooltipPosition="auto">{{dataItem.documentNumber}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Title" field="documentTitle" width="150">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.documentTitle}}" eipTooltipPosition="auto">{{dataItem.documentTitle}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Revision No" field="revisionNumber" width="60">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.revisionNumber}}" eipTooltipPosition="auto">{{dataItem.revisionNumber}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Assigned On" field="assignedOn" width="110">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.assignedOn}}" eipTooltipPosition="auto">{{dataItem.assignedOn}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Assigned To" field="assignedToName" width="110">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.assignedToName}}" eipTooltipPosition="auto">{{dataItem.assignedToName}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Completed By" field="completedByName" width="110">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.completedByName}}" eipTooltipPosition="auto">{{dataItem.completedByName}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Task" field="taskName" width="110">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.taskName}}" eipTooltipPosition="auto">{{dataItem.taskName}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Comments" field="comments" width="110">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.comments}}" eipTooltipPosition="auto">{{dataItem.comments}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="DocCategory" field="docCategoryName" width="110">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.docCategoryName}}" eipTooltipPosition="auto">{{dataItem.docCategoryName}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Delay Reason" field="delayReason" width="150">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.delayReason}}" eipTooltipPosition="auto">{{dataItem.delayReason}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Internal Reason" field="internalReason" width="110">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.internalReason}}" eipTooltipPosition="auto">{{dataItem.internalReason}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="External Reason" field="externalReason" width="110">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.externalReason}}" eipTooltipPosition="auto">{{dataItem.externalReason}}</span>
            </ng-template>
        </kendo-grid-column>
    </kendo-grid>
</div>